/**
 * 手机号变更
 */
<template>
  <div class="userbox ">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/personal/user' }">账号信息</el-breadcrumb-item>
      <el-breadcrumb-item>修改手机号码</el-breadcrumb-item>
    </el-breadcrumb>

    <div>
      <el-card class="box-card">
        <div class="box-card-content">
          <el-steps :active="active" finish-statnext上us="success">
            <el-step title="验证身份">
            </el-step>
            <el-step title="设置新手机"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>

          <div>
            <div v-show="index1" style="margin-left: 20%;margin-top:100px">
              <h5>手机验证码验证：为确认你本人操作，请完成以下验证</h5>
              <p>手机号码： {{$store.state.user.mobile}}</p>
              <p>
                <el-input v-model="captcha" placeholder="短信验证码" style="width: 200px"></el-input>
                <el-button type="danger" v-show="smsshow" style="width: 120px" @click="sendSMS1">获取验证码</el-button>
                <el-button type="info" v-show="!smsshow" style="width: 120px">已发送({{count}}s)</el-button>
                <p style="font-size:12px" v-show="!smsshow"> <i class="el-icon-success" style="color:#67c23a;"></i> <span style="color:#999">验证码已发送到你的手机，10分钟内输入有效，验证码等同于密码，打死也不能告诉别人</span> </p>
              </p>
            </div>
            <div v-show="index2" style="margin-left: 20%;margin-top:100px">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="新手机号码" prop="mobile">
                  <el-input v-model="ruleForm.mobile"></el-input>
                </el-form-item>
                <el-form-item label="短信验证码" prop="captcha">
                  <el-input v-model="ruleForm.captcha" placeholder="" style="width: 140px"></el-input>
                  <el-button type="danger" v-show="smsshow2" style="width: 120px" @click="sendSMS2">获取验证码</el-button>
                  <el-button type="info" v-show="!smsshow2" style="width: 120px">{{count}} s</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-show="index3">
              <el-result icon="success" title="手机号码修改成功" subTitle="">
                <template slot="extra">
                  <!-- <el-button class="next-button" size="medium">重新登录系统</el-button> -->
                </template>
              </el-result>
            </div>
          </div>
          <div style="text-align: center;" v-show="!index3">
            <el-button class="next-button" @click="next">下一步</el-button>
          </div>
          <div style="text-align: center;" v-show="index3">
            <el-button class="next-button" @click="closeFun">关闭</el-button>
          </div>

        </div>

      </el-card>

    </div>
  </div>
</template>

<script>
//API
import {changemobilesms1,changemobilesms2,changemobileveriry1,changemobileveriry2} from '../../api/userMG'

export default {
  data() {
    
    let checkPhone = (rule, value, callback) => {
        // let reg = /^1[345789]\d{9}$/
        let reg = /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/
        if (!reg.test(value)) {
          callback(new Error('请输入11位手机号'))
        } else {
          callback()
        }
    }
    return {
      captcha: '',
      disabled: false,
      active: 0,
      timer: null,
      smsshow: true,
      smsshow2: true,
      count: '',
      index1: true,
      index2: false,
      index3: false,
      ruleForm: {
        mobile: '',
        captcha: ''
      },
      rules: {
        mobile: [{ required: true, message: '手机号码输入不正确', trigger: 'blur' },
          { validator: checkPhone, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        captcha: [{ required: true, message: '验证码错误', trigger: 'blur' }]
      }
    }
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {},

  // 销毁前状态(里面是操作)
  beforeDestroy() {
    clearInterval(this.timer);
  },
  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    next() {
      // if (this.active > 2) this.active = 0

      switch (this.active) {
        // case 0:
          // this.index1 = true
          // this.index2 = !this.index1
          // this.index3 = !this.index1
          // this.active++ 
          // break
        case 0:
          this.verifyCode1()
          break
        case 1:
          this.verifyCode2()
          break
      }
    },
    sendSMS1() {
      const params = {}
      changemobilesms1(params).then(resp => {
        if(resp.code==0){
          this.$message.success('发送成功')
          //倒计时
          this.setTimer(1)
        }else{
          if(resp.code==1001||resp.code==1002){
            this.$message.warning(`请勿频繁发送验证码`)
          }
        }
      }, err => {
        this.$message.error('短信发送失败')
      })
        
      
    },
    sendSMS2() {
      const params = {
        sessionid: this.$cookies.get('X-session-id'),
        mobile: this.ruleForm.mobile
      }
      changemobilesms2(params).then(resp => {
        if(resp.code==0){
          this.$message.success('发送成功')
          //倒计时
          const TIME_COUNT = 60
          this.setTimer(2)
        }else{
          if(resp.code==1001 || resp.code==1002 ){
            this.$message.warning(`请勿频繁发送验证码`)
          }
        }
      }, err => {
        this.$message.error('短信发送失败')
      })
        
      
    },
    setTimer(index){
      //倒计时
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        if(index==1){
          this.smsshow = false
        }else if(index==2){
          this.smsshow2 = false
        }
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            if(index==1){
              this.smsshow = true
            }else if(index==2){
              this.smsshow2 = true
            }
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    verifyCode1(){
      const  params = {
        captcha: this.captcha
      }
      changemobileveriry1(params).then(resp => {
        if(resp.code==0){
          clearInterval(this.timer)
          this.smsshow = true
          this.captcha = ''
          this.index2 = true
          this.index1 = !this.index2
          this.index3 = !this.index2
          this.active++ 
          this.timer = null
        }else{
          this.$message.error(resp.message)
        }
      })
    },
    verifyCode2(){
      const  params = {
        captcha: this.ruleForm.captcha,
        mobile: this.ruleForm.mobile
      }
      changemobileveriry2(params).then(resp => {
        if(resp.code==0){
          this.smsshow = true
          this.index3 = true
          this.index2 = !this.index3
          this.index1 = !this.index3
          this.active++ 
          this.timer = null
        }else{
          this.$message.error(resp.message)
        }
      })
    },
    closeFun(){
      this.$router.push({ path: '/personal/user' })
    }
  }
}
</script>

<style scoped>
.box-card {
  /* width: 100%; */
  margin-top: 20px;
}
.box-card-content {
  width: 80%;
  margin-left: 10%;
}
.next-button {
  margin-top: 80px;
  background-color: rgb(211, 110, 105);
  color: rgb(255, 255, 255);
}
</style>

<style >
.el-step__head.is-process .el-step__icon {
  background-color: #d36e69;
  /* color: #fff; */
  /* border-color: tomato; */
}
.el-step__head.is-process {
  color: #fff;
  border-color: #d36e69;
}
.el-step__line {
  margin-right: 5px !important;
  margin-left: 30px;
}
.el-step__title.is-process {
  color: #d36e69;
}
.userbox .el-form .el-input {
  width: 270px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/personal/mobilechange.vue